import React from 'react';
import PropTypes from 'prop-types';
import css from 'scss';

const Modal = (props) => {
    // Render nothing if the "show" prop is false
    if (!props.show) {
      return null;
    }

    document.body.classList.add('fixed');

    const modalStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10,
    };
    const overlayStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(0,0,0,0.8)',
    };
    const closeStyle = {
      position: 'absolute',
      top: '20px',
      right: '20px',
      cursor: 'pointer',
    };
    const windowStyle = {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      left: '50%',
      top: '50%',
      background: css['$color-yellow'],
      padding: '30px 50px',
      color: css['$color-black'],
      minWidth: '300px',
      zIndex: 1,
    };

    return (
      <div className="modal__wrapper" style={modalStyle}>
        <div className={`modal modal--popup  ${props.additionalClass}`} style={windowStyle}>
          <div className="modal__close icon-close" onClick={props.close} style={closeStyle} />
          <div className="modal__content">
            {props.children}
          </div>
        </div>
        <div className="overlay fixed top no-icon animating" style={overlayStyle} />
      </div>
    );
}

Modal.defaultProps = {
  additionalClass: '',
  show: false,
};

Modal.propTypes = {
  close: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node,
  additionalClass: PropTypes.string,
};

export default Modal;



// WEBPACK FOOTER //
// ./sources/js/components/global/Modal.js